import * as swcHelpers from '@swc/helpers';
import { isDefined } from '@grandvisionhq/utils';
import '../../../../types/product.js';
import { isSubscriptionPurchase } from '../../../../types/typeguards.js';

const mapColumnToDraftLineItem = (state, eyeSide, priceSegmentChannelKey)=>{
    const { configurations , configurator , queries  } = state;
    if (configurator[eyeSide].isEnabled) {
        const sku = queries[eyeSide].sku;
        if (!sku) {
            return;
        }
        const isSubscription = isSubscriptionPurchase(state.configurations.purchaseType);
        const { quantity , prescription  } = configurations[eyeSide];
        const segments = priceSegmentChannelKey ? [
            {
                channelKey: priceSegmentChannelKey
            }
        ] : undefined;
        const lineItemDraft = {
            sku,
            type: 'contact-lenses',
            quantity,
            typeDetails: {
                eyeSide,
                contactLensPrescription: prescription,
                segments
            }
        };
        if (isSubscription) {
            const deliveryInterval = state.configurations.subscriptionPurchaseConfigurations.deliveryInterval;
            if (!deliveryInterval) {
                return;
            }
            lineItemDraft.typeDetails = swcHelpers.objectSpread({}, lineItemDraft.typeDetails, {
                isSubscription: true,
                subscriptionDetails: {
                    deliveryInterval
                }
            });
        }
        return lineItemDraft;
    }
    return;
};
const mapContactLensesToDraftLineItems = (state, isOneColConfigurator, priceSegmentChannelKey)=>{
    let lineItemDrafts = [];
    if (isOneColConfigurator) {
        lineItemDrafts = [
            mapColumnToDraftLineItem(state, 'both', priceSegmentChannelKey)
        ];
    } else {
        lineItemDrafts = [
            mapColumnToDraftLineItem(state, 'left', priceSegmentChannelKey),
            mapColumnToDraftLineItem(state, 'right', priceSegmentChannelKey), 
        ];
    }
    return lineItemDrafts.filter(isDefined);
};

export { mapContactLensesToDraftLineItems };
//# sourceMappingURL=map-contact-lenses-to-draft-line-items.js.map
